/**
 * =========================================================================================
 *     Copyright © 2026 Dobler Data Solutions, LLC. ALL RIGHTS RESERVED.
 * =========================================================================================
 *     File            :   nullDisplay.ts
 *     Feature         :   138-dashboard-data-enrichment
 *     Description     :   NULL value display utility — returns em dash for null/undefined/empty
 *     Constitution    :   v1.12.0 | Principle XXXVII (Code Headers)
 *     Author          :   Peter Dobler
 *     Created         :   2026-02-21
 * =========================================================================================
 *
 * FR-023: All NULL values in enriched dashboard columns MUST display as "—" (em dash).
 * Used as renderCell helper in MUI DataGrid columns across all operational dashboards.
 */

/**
 * Format a value for display, returning "—" (em dash) for null, undefined, or empty string.
 * For all other values, returns String(value).
 *
 * @param value - The value to display
 * @returns The formatted string, or "—" for null/undefined/empty
 *
 * @example
 * nullDisplay(null)      // "—"
 * nullDisplay(undefined) // "—"
 * nullDisplay('')        // "—"
 * nullDisplay(0)         // "0"
 * nullDisplay(42.5)      // "42.5"
 * nullDisplay('Active')  // "Active"
 */
export function nullDisplay(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return String(value);
}
